import {
  AnnotatedJsonSchema,
  EntityDetailSchemaWithRelationships,
  EntityDetailSchemaWithoutRelationships,
} from '@web-config-app/core';
import { set, cloneDeep, get } from 'lodash-es';

const isEntityDetailsSchemaWithRelationships = (
  schema:
    | EntityDetailSchemaWithRelationships
    | EntityDetailSchemaWithoutRelationships,
): schema is EntityDetailSchemaWithRelationships =>
  !!schema.properties?.relationships &&
  !!schema.properties?.relationships.properties;

/**
 * Updates the `type` of every relationship in the schema to include
 * the original value as well as `config-entity`. This is only used currently
 * at the point of validation and only when using the config app BE.
 */

export const transposeRelationshipsForConfigEntitySchema = (
  schema:
    | EntityDetailSchemaWithRelationships
    | EntityDetailSchemaWithoutRelationships,
) => {
  if (!isEntityDetailsSchemaWithRelationships(schema)) {
    return schema;
  }

  const schemaCopy = cloneDeep(schema);
  const { relationships } = schemaCopy.properties;

  const transposedToConfigEntityRelationships = Object.entries(
    relationships.properties ?? {},
  ).reduce(
    (
      acc,
      [relationship, relationshipSchema]: [string, AnnotatedJsonSchema],
    ) => {
      const relationshipDataSchema = relationshipSchema.properties?.data;

      if (!relationshipDataSchema || !relationshipSchema.properties) {
        return acc;
      }

      if (relationshipDataSchema?.type === 'array') {
        const relationshipEntityType = get(
          relationshipSchema,
          'properties.data.items.properties.type.enum[0]',
        );
        set(relationshipDataSchema, 'items.properties.type.enum', [
          'config-entity',
          relationshipEntityType,
        ]);
      } else {
        const relationshipEntityType = get(
          relationshipSchema,
          'properties.data.properties.type.enum[0]',
        );
        set(relationshipDataSchema, 'properties.type.enum', [
          'config-entity',
          relationshipEntityType,
        ]);
      }

      return set(
        acc,
        `${relationship}.properties.data`,
        relationshipDataSchema,
      );
    },
    {},
  );

  return set(
    schemaCopy,
    'properties.relationships.properties',
    transposedToConfigEntityRelationships,
  );
};
